import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { MASK } from "@/tz/go/egaz/osci/lpco/comn/LpcoConstants";
/*
 *  Application Assignment Settings
 * !== Application Assignment Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${lpcoEnvs.base}/lpco/app/asin`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/asin`,
    nodes: [
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_LPCO" },
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_CFGN" },
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_LPCO_APP_SETT" },
        { path: "/lpco/app/asin/osci0201026q", label: "T_LPCO_APP_ASNMT_MDFC" },
    ],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
/**
신청서 배부 수정(수동 할당)
*/
export const URLS = {
    osci0201026q: `${BASE.path}/osci0201026q`, // Register Application Assignment List  !== 신청서 배부 목록 조회  ==!
    osci0201027s: `${BASE.path}/osci0201027s`, // Application Assignment Modification  !== 신청서 배부 상세 조회 ==!
    osci0201028s: `${BASE.path}/osci0201028s`, // Application Assignment Modification  !== 합동 검사 배부 상세 조회 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    /* Application Assignment inquiry !== Application Assignment 목록 조회 ==! */
    getRsptyList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    /* LPCO Assignments detailed inquiry !== Application Assignment 상세 조회 ==! */
    getRsptyInfo: (data: any) => {
        console.log("getAppAsinDtl :: ", data);
        return api.get(`${BASE.api}/${data.appId}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    /* Register LPCO information !== Application Assignment 등록 ==! */
    createChangeRspty: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    getJntInscRsptyInfo: (tansadNo: any) => {
        return api.get(`${BASE.api}/insc/${tansadNo}`, {});
    },
    createChangeInscRspty: (data: any) => {
        return api.post(`${BASE.api}/insc`, {
            ...data,
        });
    },
};

/*
 * @ Form 스키마 정의
 * @ 화면에서 사용하는 Form 구조 정의
 * @ SF_ 로 시작 (Schema form)
 * @ SF_[Form 이름 메타 대문자, "_" 로 구분 ]
 * @ 검색폼은 _SRCH 로 구분
 */
export const SF_LPCO_INFO_R: TFormSchema = {
    id: "form_LpcoInfo",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            controlSize: 10,
            edit: false,
        } /* OGA */,
        orgNm: { type: "text", label: "L_OGA", edit: false } /* OGA Name */,
        appCdNo: {
            type: "select",
            label: "L_LPCO",
            required: true,
            edit: false,
        } /* L_LPCO */,
        appNm: {
            type: "text",
            label: "L_LPCO",
            required: true,
            edit: false,
        } /* L_LPCO */,
    },
};

export const SF_LPCO_INFO_U: TFormSchema = {
    id: "form_LpcoInfo",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            controlSize: 10,
            edit: false,
        } /* OGA */,
        orgNm: { type: "text", label: "L_OGA", edit: false } /* OGA Name */,
        appCdNo: {
            type: "select",
            label: "L_LPCO",
            edit: true,
            controlSize: 10,
            required: true,
        } /* L_LPCO */,
        appNm: {
            type: "text",
            label: "L_LPCO",
            edit: false,
            controlSize: 10,
        } /* L_LPCO */,
    },
};

/*
 * @ 그리드 스키마 정의
 * @ 화면에서 사용하는 그리드 구조 정의
 * @ SG_ 로 시작 (Schema grid)
 * @ SG_[그리드명가 조회하는 데이터 이름 메타 단어(용어) 대문자, "_" 로 구분 , 그리드명 맨 뒤에 "_LIST" 로 종료]
 */

// LPCO Search Schema !== LPCO Search Schema ==!
export const SF_LPCO_SRCH: TFormSchema = {
    id: "form_LpcoSrch",
    schema: {
        orgNm: { type: "text", label: "L_OGA", edit: false } /* oga */,
        srchAppCdNo: { type: "select", label: "L_LPCO", edit: true, all: true } /* lpco */,
        srchUcrNo: { type: "text", label: "L_UCR_NO", edit: true } /* UCR No */,
        srchAsnmtOfcrTpCd: {
            type: "select",
            label: "L_OFCR_ROLE",
            all: true,
            area: "comnCd",
            comnCd: "OSC0119",
            excludes: ["AC", "MA", "DT", "LC", "CC", "CK"],
        } /* Officer Role */,
        srchJntAsnmtOfcrTpCd: {
            type: "select",
            label: "L_OFCR_ROLE",
            all: false,
            area: "comnCd",
            comnCd: "OSC0119",
            excludes: ["AC", "MA", "DT", "LC", "CC", "EF", "ES", "EV", "FR", "VA", "VE", "CK"],
            defaultValue: "IP",
        } /* Officer Role */,
        srchAsnmtOfcrId: {
            label: "L_ASNMT_OFCR",
            type: "text",
        } /*  Assigned Officer */,
        srchAppNo: {
            type: "text",
            label: "L_APP_NO",
        } /* Application No. */,
        srchAplcTin: {
            type: "text",
            label: "L_APLC_TIN",
        } /* Applicant TIN */,
        srchAsnmtBsopTpCd: {
            type: "select",
            label: "L_ASNMT_BSOP_TP",
            area: "comnCd",
            comnCd: "OSC0118",
            required: true,
            excludes: ["ABO02"],
            select: false,
        },
        srchAsinMetdCd: {
            type: "checkbox",
            label: "L_ASIN_CTRA",
            comnCd: "OSC0038",
            area: "comnCd",
            all: true,
            excludes: ["0", "C"],
        },

        srchHsAppNo: {
            type: "text",
            label: "L_APP_NO",
        },
        srchOrgCd: {
            type: "select",
            label: "L_ORG",
        },
        srchOrgChpnNm: {
            type: "text",
            label: "L_OGA_OFCR_NM",
        },
        srchSbmsDt: {
            type: "daterange",
            label: "L_SBMS_DT",
            edit: true,
            start: {
                name: "srchSbmsDtStart",
            },
            end: {
                name: "srchSbmsDtEnd",
            },
        },
        tansadNo: {
            label: "L_TANSAD_NO",
            controlSize: 2,
        } /* TANSAD No !== TANSAD 번호 ==! */,
        cstmOfceCd: {
            type: "text",
            controlSize: 1,
            only: "control",
            maxLength: 4,
        } /* Customs Office Code !== 세관 사무소 코드 ==! */,
        tansadYy: {
            type: "text",
            controlSize: 1,
            only: "control",
            imemode: "number",
            maxLength: 2,
        } /* TANSAD Year !== TANSAD 년도 ==! */,
        tansadSrno: {
            type: "text",
            controlSize: 1,
            only: "control",
            imemode: "number",
            maxLength: 7,
        } /* TANSAD Serial Number !== TANSAD 일련번호 ==! */,
        godsLoctWrhsCd: {
            type: "code",
            area: "wrhsCd",
            label: "L_LOCT_GODS",
        } /* Location of Goods !== 물품 위치 ==! */,
    },
};

// LPCO Settings List Grid Schema !== LPCO 설정 목록 그리드 스키마 ==!
export const SG_LPCO_LIST_R: TGridSchema = {
    id: "grid_lpcoList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: false, // 그리드 편집 가능 여부 , default : false
    },
    head: [
        { cells: [{ header: "L_LPCO", binding: "appNm", width: 220, rowspan: 2 }] } /* LPCO */,
        {
            cells: [
                { header: "L_UCR_NO", binding: "ucrNo", width: 250 } /* UCR No */,
                { header: "L_APP_NO", binding: "appNo" } /* Application No */,
            ],
        },
        { cells: [{ header: "L_CSTM", binding: "cstmOfceCd", width: 100, rowspan: 2 }] } /* Customs Office */,
        {
            cells: [{ header: "L_APLC_TIN", binding: "aplcTin", width: "*", minWidth: 400, rowspan: 2 }],
        } /* Applicant TIN*/,
        {
            cells: [
                { header: "L_SBMT_DT", binding: "sbmtDtm", width: 200 } /* Submission Date */,
                { header: "L_APP_STTS", binding: "appStatCd" } /* Application Status */,
            ],
        },
        {
            cells: [
                { header: "L_OFCR_ROLE", binding: "asnmtOfcrTpCdNm", width: 220 } /* Officer Role */,
                { header: "L_ASNMT_OFCR", binding: "asnmtOfcrNm" } /* Assigned Officer */,
            ],
        },
    ],
    body: [
        { cells: [{ binding: "appNm", align: "center", rowspan: 2 }] },
        {
            cells: [
                { binding: "ucrNo", align: "left" },
                { binding: "appNo", align: "left" },
            ],
        },
        { cells: [{ binding: "cstmOfceCd", align: "center", rowspan: 2 }] },
        { cells: [{ binding: "aplcTin", align: "left", rowspan: 2 }] },
        {
            cells: [
                { binding: "sbmtDtm", type: "date" },
                {
                    binding: "appStatCd",
                    align: "center",
                    area: "comnCd",
                    comnCd: "OSC0121",
                    type: "select",
                    viewType: "label",
                },
            ],
        },
        {
            cells: [
                {
                    binding: "asnmtOfcrTpCd",
                    align: "center",
                    area: "comnCd",
                    comnCd: "OSC0119",
                    type: "select",
                    viewType: "label",
                    excludes: ["AC", "MA", "DT", "LC", "CC"],
                },
                { binding: "asnmtOfcrNm", align: "left" },
            ],
        },
    ],
};

export const SG_HS_APP_LIST_R: TGridSchema = {
    id: "grid_hsAppList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 410,
    },
    head: [
        { cells: [{ header: "L_OGA", binding: "orgNm", width: "*" }] },
        { cells: [{ header: "L_APP_NO", binding: "hsAppNo", width: "*" }] },
        { cells: [{ header: "L_OGA_OFCR_NM", binding: "orgChpnNm", width: "*" }] },
        { cells: [{ header: "L_SBMT_DT", binding: "sbmtDtm", width: "*" }] },
        { cells: [{ header: "L_STTS", binding: "hsStatCd", width: "*" }] },
        { cells: [{ header: "L_OFCR_ROLE", binding: "asnmtOfcrTpCdNm", width: "*" }] } /* Officer Role */,
        { cells: [{ header: "L_ASNMT_OFCR", binding: "asnmtOfcrNm", width: "*" }] } /* Assigned Officer */,
    ],
    body: [
        { cells: [{ binding: "orgNm" }] },
        { cells: [{ binding: "hsAppNo" }] },
        { cells: [{ binding: "orgChpnNm", align: "left" }] },
        { cells: [{ binding: "sbmtDtm", type: "date" }] },
        { cells: [{ binding: "hsStatCd", type: "select", area: "comnCd", comnCd: "OSC0132" }] },
        {
            cells: [
                {
                    binding: "asnmtOfcrTpCd",
                    align: "left",
                    area: "comnCd",
                    comnCd: "OSC0119",
                    type: "select",
                    excludes: ["AC", "MA", "DT", "LC", "CC"],
                },
            ],
        },
        { cells: [{ binding: "asnmtOfcrNm", align: "left" }] },
    ],
};

// LPCO Assignment Info Schema
export const SF_APP_ASIN_INFO: TFormSchema = {
    id: "form_appAsinInfo",
    schema: {
        orgNm: { type: "text", label: "L_OGA", edit: false } /* oga */,
        appNm: { type: "text", label: "L_LPCO", edit: false } /* lpco */,
        ucrNo: { type: "text", label: "L_UCR_NO", edit: false } /* UCR No */,
        asnmtOfcrTpCd: {
            type: "select",
            label: "L_OFCR_ROLE",
            area: "comnCd",
            comnCd: "OSC0119",
            edit: false,
            excludes: ["AC", "MA", "DT", "LC", "CC"],
        } /* Officer Role */,

        asnmtOfcrNm: {
            label: "L_ASNMT_OFCR",
            type: "text",
            edit: false,
        } /*  Assigned Officer */,
        appNo: {
            type: "text",
            label: "L_APP_NO",
            edit: false,
        } /* Application No. */,
        aplcTin: {
            type: "text",
            label: "L_APLC_TIN",
            edit: false,
        } /* Applicant TIN */,
        orgChpnNm: {
            type: "text",
            label: "L_OGA_OFCR_NM",
            edit: false,
        },
    },
};

export const SF_APP_ASIN_NEW: TFormSchema = {
    id: "form_appAsinNewInfo",
    schema: {
        asnmtOfcrNm: {
            label: "L_ASNMT_OFCR",
            type: "text",
            edit: false,
        } /*  Assigned Officer */,
        newAsnmtOfcrNm: {
            type: "text",
            label: "L_NEW_ASIN_OFCR",
            edit: true,
            disabled: true,
            required: true,
        } /* Application No. */,
        asinMdfyRsn: {
            label: "L_RE_ASNMT_RSN",
            type: "textarea",
            rows: 5,
            maxLength: 2000,
        } /*  Re-assignment Reason */,
    },
};

// LPCO Assignment Schema !== LPCO Assignment Schema ==!
export const SG_LPCO_ASIN_LIST_U: TGridSchema = {
    id: "grid_cpntRList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: true, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: false, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: true, // 그리드 편집 가능 여부 , default : false
        height: 300,
    },
    head: [
        { cells: [{ header: "L_OFCR_ROLE", binding: "asnmtOfcrTpCd", width: "*" }] } /* Process Name */,
        { cells: [{ header: "L_OPT", binding: "asinMetdCd", width: "*" }] } /* Process Name */,
        // { cells: [{ header: "L_DESC", binding: "asinDesc", width: "*" }] } /* Descriptions */,
    ],
    body: [
        {
            cells: [
                {
                    binding: "asnmtOfcrTpCd",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0119",
                    area: "comnCd",
                    edit: true,
                    required: true,
                    excludes: ["AC", "MA", "DT", "LC", "CC"],
                },
            ],
        },
        {
            cells: [
                {
                    binding: "asinMetdCd",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0038",
                    area: "comnCd",
                    edit: true,
                    required: true,
                    excludes: ["0", "C"],
                },
            ],
        },
        // { cells: [{ binding: "asinDesc", align: "left", type: "text", edit: true }] },
    ],
};

/*
 * @ 그리드 스키마 정의
 * @ 화면에서 사용하는 그리드 구조 정의
 * @ SG_ 로 시작 (Schema grid)
 * @ SG_[그리드명가 조회하는 데이터 이름 메타 단어(용어) 대문자, "_" 로 구분 , 그리드명 맨 뒤에 "_LIST" 로 종료]
 */

// LPCO Settings List Grid Schema !== LPCO 설정 목록 그리드 스키마 ==!
export const SG_LPCO_ASIN_LIST_R: TGridSchema = {
    id: "grid_cpntRList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 200,
    },
    head: [
        { cells: [{ header: "L_OFCR_ROLE", binding: "asnmtOfcrTpCd", width: "*" }] } /* Process Name */,
        { cells: [{ header: "L_OPT", binding: "asinMetdCd", width: "*" }] } /* Process Name */,
        // { cells: [{ header: "L_DESC", binding: "asinDesc", width: "*" }] } /* Descriptions */,
    ],
    body: [
        {
            cells: [
                {
                    binding: "asnmtOfcrTpCd",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0119",
                    area: "comnCd",
                    excludes: ["AC", "MA", "DT", "LC", "CC"],
                },
            ],
        },
        {
            cells: [
                {
                    binding: "asinMetdCd",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0038",
                    area: "comnCd",
                    excludes: ["0", "C"],
                },
            ],
        },
        // { cells: [{ binding: "asinDesc", align: "left", type: "text", edit: true }] },
    ],
};

export const SG_JNT_INSC_LIST_R: TGridSchema = {
    id: "grid_jntInscList",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true },
    head: [
        { cells: [{ header: "L_TANSAD_NO", binding: "tansadNo", width: "*" }], id: "tansadNo" },
        { cells: [{ header: "L_REFF_NO", binding: "reffNo", width: "*" }], id: "reffNo" },
        { cells: [{ header: "L_CAG_TP", binding: "cntrLstCn", width: "*" }], id: "cntrLstCn" },
        { cells: [{ header: "L_BKNG_RQST_DT", binding: "bkngRqstDt", width: "*" }], id: "bkngRqstDt" },
        { cells: [{ header: "L_STAT", binding: "prcssStatCd", width: "*" }], id: "prcssStatCd" },
        { cells: [{ header: "L_OFCR_ROLE", binding: "asnmtOfcrTpCdNm", width: 220 }] } /* Officer Role */,
        { cells: [{ header: "L_ASNMT_OFCR", binding: "asinOfcrId", width: 220 }] } /* Assigned Officer */,
    ],
    body: [
        {
            cells: [{ binding: "tansadNo", mask: MASK.TANSAD_NO }] /* TANSAD No !== TANSAD 번호 ==! */,
        },
        {
            cells: [{ binding: "reffNo", mask: MASK.REFF_NO }] /* Reference No !== 참조 번호 ==! */,
        },
        {
            cells: [{ binding: "cntrLstCn" }] /* Cargo Type !== 화물 구분 ==! */,
        },
        {
            cells: [
                { binding: "bkngRqstDt", edit: false, type: "date" },
            ] /* Booking Request Date !== 예약 요청 일자 ==! */,
        },
        {
            cells: [{ binding: "prcssStatCd" }] /* Status !== 상태 ==! */,
        },
        {
            cells: [
                {
                    binding: "asnmtOfcrTpCd",
                    align: "left",
                    area: "comnCd",
                    comnCd: "OSC0119",
                    type: "select",
                    excludes: ["AC", "MA", "DT", "LC", "CC"],
                },
            ],
        },
        { cells: [{ binding: "asinOfcrId", align: "left" }] },
    ],
};

// LPCO Assignment Info Schema
export const SF_JNT_INSC_ASIN_INFO: TFormSchema = {
    id: "form_jntInscAsinInfo",
    schema: {
        orgNm: { type: "text", label: "L_OGA", edit: false } /* oga */,
        tansadNo: { type: "text", label: "L_TANSAD_NO", edit: false },
        cntrLstCn: { type: "text", label: "L_CAG_TP", edit: false } /* lpco */,
        godsLoctWrhsCd: {
            type: "code",
            area: "wrhsCd",
            label: "L_LOCT_GODS",
            edit: false,
        } /* Location of Goods !== 물품 위치 ==! */,
        asnmtOfcrTpCd: {
            type: "select",
            label: "L_OFCR_ROLE",
            area: "comnCd",
            comnCd: "OSC0119",
            edit: false,
        } /* Officer Role */,
        asinOfcrId: {
            label: "L_ASNMT_OFCR",
            type: "text",
            edit: false,
        } /*  Assigned Officer */,
        reffNo: {
            label: "L_REFF_NO",
            controlSize: 2,
            edit: false,
        } /* Reference Number !== 참조 번호 ==! */,
        reffTin: {
            type: "text",
            controlSize: 1,
            maxLength: 9,
            imemode: "number",
            edit: false,
        } /* Reference TIN !== 참조 TIN ==! */,
        reffYy: {
            type: "text",
            controlSize: 1,
            maxLength: 2,
            imemode: "number",
            edit: false,
        } /* Reference Year !== 참조 년도 ==! */,
        reffSrno: {
            type: "text",
            controlSize: 1,
            maxLength: 7,
            imemode: "number",
            edit: false,
        } /* Reference Serial Number !== 참조 일련 번호 ==! */,
    },
};

export const SF_JNT_INSC_ASIN_NEW: TFormSchema = {
    id: "form_jntInscAsinNewInfo",
    schema: {
        asinOfcrId: {
            label: "L_ASNMT_OFCR",
            type: "text",
            edit: false,
        } /*  Assigned Officer */,
        newAsinOfcrId: {
            type: "text",
            label: "L_NEW_ASIN_OFCR",
            edit: true,
            disabled: true,
            required: true,
        } /* Application No. */,
        asinMdfyRsn: {
            label: "L_RE_ASNMT_RSN",
            type: "textarea",
            rows: 5,
            maxLength: 2000,
        } /*  Re-assignment Reason */,
    },
};
